GP.GPMod('Video',function(self){
    var videojs_conf = {
        // techOrder: ["html5", "flash"],
        controls:true,
        autoplay:false,
        volume:0.5,
        controlsBelow: false, // Display control bar below video instead of in front of
        controlsHiding: false, // Hide controls when mouse is not over the video
        defaultVolume: 0.85, // Will be overridden by user's last volume if available
        flashPlayerVersion: 9, // Required flash version for fallback
        linksHiding: true, // Hide download links when video is supported,
        nativeControlsForTouch: true,
        flash: {
            // swf: "/assets/flash/video-js.swf"
            // swf: "/assets/flash/video-js-5.3.0.swf"
            swf: "/assets/flash/video-js-5.4.1.swf"
        }
    };

    var _current_player = null;

    var events = {
        init: function() {
            self.vent.on('Video:setup', this.handle_video_setup);
            self.vent.on('Video:close', this.handle_video_close);

            GP.reqres.setHandler("Video:get_time_index", function() {
                var current_time;

                if (videojs && GP.Util.check_nested(videojs, 'players.video_player')) {
                    current_time = videojs.players.video_player.currentTime();
                    return current_time;
                } else {
                    var tmp_player = document.getElementById('video_player');
                    current_time = tmp_player.currentTime;

                    if (current_time) {
                        return current_time;
                    }
                }
            });
        },
        handle_video_setup: function(p_cb, p_ctx) {
            // don't setup videojs for unconverted_trial users or pending free users
            if (GP.sdata.my_user.unconverted_trial || GP.sdata.my_user.membership === 'PENDING_FREE') {
                return;
            }

            // callback function to call after loading videojs, or right away if it's already loaded
            var cb = events.setup_video;
            if (typeof p_cb == 'function') {
                cb = p_cb;
            }

            // context for callback function (either this or p_ctx if it was supplied)
            var ctx = this;
            if (p_ctx) {
                ctx = p_ctx;
            }

            // either setup and play the video if we already have the videojs script, if not, grab it
            // more efficient this way, since videojs is over 400K minified :-/
            if (typeof videojs != 'undefined') {
                self.app.Util.log("videojs already loaded, calling callback function immediately");
                cb.call(ctx);
            } else {
                $.ajax({
                    url: (_vjs_script_url || '/js_v3/video.js'),
                    dataType: "script",
                    cache: true // we can make use of cache because we already use the timestamp as part of the path
                })
                .done(function() {
                    self.app.Util.log("videojs loaded successfully... calling callback function");
                    cb.call(ctx);
                })
                .fail(function() {
                    self.app.Util.log("videojs loading failed");
                });
            }
        },
        setup_video: function() {
            if (typeof videojs != 'undefined') {

                if (!self.app.Util.is_mobile()) {
                    videojs_conf.autoplay = true;
                }

                _current_player = videojs("video_player", videojs_conf, function() {
                    if (!self.app.Util.is_mobile()) {
                        this.play();
                    }
                    this.volume(0.5);
                });
            }
        },
        handle_video_close: function() {
            if (typeof videojs != 'undefined' && videojs) {

                var _players = videojs.getPlayers();

                for (var vjs_instance in _players) {
                    if (_players.hasOwnProperty(vjs_instance) && vjs_instance != 'profile_vchat_video') {
                        if (_players[vjs_instance] !== null && typeof _players[vjs_instance].dispose == 'function') {
                            _players[vjs_instance].dispose();
                        }
                    }
                }

                if (_current_player && typeof _current_player.dispose == 'function') {
                    _current_player.dispose();
                }
                _current_player = null;
            }
        }
    };

    this.addInitializer(function(){
        events.init();
    });
});
